import * as React from 'react';
import { IRequestFormProps } from './request-form.props.autogenerated';
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */

// tslint:disable-next-line: no-any
export interface IRequestFormExtendedProps extends IRequestFormProps<any> {

}

export interface IRequestFormViewProps {
    className?: string;
    captchaKey?: string;
}

/**
 *
 * Form component
 */
class RequestForm extends React.Component<IRequestFormExtendedProps> {

    constructor(props: IRequestFormExtendedProps) {
        super(props);
    }

    public componentDidMount(): void {
        const script = document.createElement('script');
        script.src =
          'https://www.google.com/recaptcha/api.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }

    public render(): JSX.Element | null {
        const { renderView } = this.props;
        return renderView(this.props) as React.ReactElement;
    }
}

export default RequestForm;
